import helloWorld from './helloWorld.example'
helloWorld()
